import { TConvertor, TCreateConverter } from '../types/Converter.types';

import {
  EAnimalTagDB,
  EAnimalTagUI,
  ETenantTagDB,
  ETenantTagUI,
} from '../types/Tags.types';

export const tenantTagConverter: TConvertor<ETenantTagUI, ETenantTagDB> = {
  fromDb: data => {
    const statuses: {
      [key in ETenantTagDB]: ETenantTagUI;
    } = {
      [ETenantTagDB.KNOWN]: ETenantTagUI.KNOWN,
    };
    return statuses[data];
  },
  toDb: data => {
    const statuses: {
      [key in ETenantTagUI]: ETenantTagDB;
    } = {
      [ETenantTagUI.KNOWN]: ETenantTagDB.KNOWN,
    };
    return statuses[data];
  },
};
export const isDiscoveredTag = (tag: EAnimalTagUI) =>
  tag === EAnimalTagUI.DISCOVERED ||
  tag === EAnimalTagUI.DISCOVERED_APP ||
  tag === EAnimalTagUI.DISCOVERED_PAYING;

export const hasDiscoveredTag = (tags: EAnimalTagUI[]) =>
  tags.some(tag => isDiscoveredTag(tag));

export const tagConverter: TConvertor<EAnimalTagUI, EAnimalTagDB> = {
  fromDb: data => {
    const statuses: {
      [key in EAnimalTagDB]: EAnimalTagUI;
    } = {
      [EAnimalTagDB.KNOWN]: EAnimalTagUI.KNOWN,
      [EAnimalTagDB.DISCOVERED]: EAnimalTagUI.DISCOVERED,
      [EAnimalTagDB.DISCOVERED_APP]: EAnimalTagUI.DISCOVERED_APP,
      [EAnimalTagDB.DISCOVERED_PAYING]: EAnimalTagUI.DISCOVERED_PAYING,
      [EAnimalTagDB.PNC_PET_FEE]: EAnimalTagUI.PNC_PET_FEE,
      [EAnimalTagDB.PNC_PET_RENT]: EAnimalTagUI.PNC_PET_RENT,
    };
    return statuses[data];
  },
  toDb: data => {
    const statuses: {
      [key in EAnimalTagUI]: EAnimalTagDB;
    } = {
      [EAnimalTagUI.KNOWN]: EAnimalTagDB.KNOWN,
      [EAnimalTagUI.PNC_PET_FEE]: EAnimalTagDB.PNC_PET_FEE,
      [EAnimalTagUI.PNC_PET_RENT]: EAnimalTagDB.PNC_PET_RENT,
      [EAnimalTagUI.DISCOVERED]: EAnimalTagDB.DISCOVERED,
      [EAnimalTagUI.DISCOVERED_APP]: EAnimalTagDB.DISCOVERED_APP,
      [EAnimalTagUI.DISCOVERED_PAYING]: EAnimalTagDB.DISCOVERED_PAYING,
    };
    return statuses[data];
  },
};
